export const COURSE_MAP = {
  
  SUMMER_CAMP:"summer_camp",
  EVENT:"event",
  NORMAL_COURSES:"normal",
  UPSKILL_4_TEACHER:"upskill_teacher"
  
};
